<template>
  <a-modal
    title="商品信息"
    :width="700"
    :visible="visible"
    @cancel="handleCancel"
    :footer="false"
  >
  <a-spin :spinning="loading">
    <div class="goods-container">
      <a-list itemLayout="horizontal" :dataSource="list" :split="false">
        <a-list-item slot="renderItem" slot-scope="item">
          <goods-card class="goods-card" :goodsinfo="item"></goods-card>
        </a-list-item>
      </a-list>
    </div>
  </a-spin>
  </a-modal>
</template>

<script>
import ActivityApi from '@/api/activity'
import GoodsCard from '@/views/activity/components/GoodsCard'
export default {
  components: {
    GoodsCard
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      confirmLoading: false,
      list: [],
      loading: false
    }
  },
  created() {
  },
  methods: {
    show(list) {
      this.list = list
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>

</style>
